import React, { useEffect, useRef } from "react";

const GROUPS = [
  { label: "Смайлы", emojis: "😀 😁 😂 🤣 😊 😍 🥰 😘 🙂 😉 😎 🤔 😐 😅 😢 😭 😡 😱 🥳 😴".split(" ") },
  { label: "Жесты", emojis: "👍 👎 👏 🙏 🤝 💪 👌 🤞 ✌️ 🙌 👋 🤗".split(" ") },
  { label: "Сердца", emojis: "❤️ 🧡 💛 💚 💙 💜 🖤 🤍 💔 💯".split(" ") },
  { label: "Медицина", emojis: "🩺 💉 💊 🩹 🧬 🫀 🧠 🦴 🩻 🚑 🏥 🔬".split(" ") },
  { label: "Прочее", emojis: "🔥 ⭐ ✅ ❌ ⚠️ 📎 📷 📌 🎉 ⏰".split(" ") },
];

export default function EmojiPicker({ onSelect, onClose }) {
  const ref = useRef(null);

  useEffect(() => {
    const handler = e => { if (ref.current && !ref.current.contains(e.target)) onClose(); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [onClose]);

  return (
    <div ref={ref} style={{
      position: "absolute", bottom: "100%", left: 0, marginBottom: 8,
      background: "#fff", border: "1px solid #e0e3ee", borderRadius: 12,
      boxShadow: "0 8px 24px rgba(0,0,0,0.12)", padding: "10px 12px",
      width: 280, maxHeight: 260, overflowY: "auto", zIndex: 20,
    }}>
      {GROUPS.map(g => (
        <div key={g.label} style={{ marginBottom: 8 }}>
          <div style={{ fontSize: "0.72rem", color: "#999", marginBottom: 4, fontWeight: 600 }}>{g.label}</div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
            {g.emojis.map(e => (
              <button
                key={e}
                type="button"
                onClick={() => onSelect(e)}
                style={{
                  background: "none", border: "none", cursor: "pointer",
                  fontSize: "1.25rem", padding: "3px 5px", borderRadius: 6, lineHeight: 1.2,
                }}
                onMouseEnter={ev => ev.currentTarget.style.background = "#f0f2f8"}
                onMouseLeave={ev => ev.currentTarget.style.background = "none"}
              >
                {e}
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
